import {IGrpdPService} from "./IGrpdPService";
import {ILocalStorage} from "./ILocalStorage";

export class GrpdService implements IGrpdPService{

    private PRIVACY_POLICY = 'privacy_policy';

    constructor(private localStorage:ILocalStorage) {

    }

    public Accept(): void {
        this.localStorage.Set(this.PRIVACY_POLICY, 'accepted');
    }

    public IsAccepted(): Promise<boolean> {
        return Promise.resolve(this.localStorage.Get(this.PRIVACY_POLICY) == 'accepted');
    }



}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/privacy-policy/GrpdService.ts